import { useCallback, useEffect, useState } from 'react';
import { listQueue, processQueue, type ProcessQueueResult } from '../lib/offline';
import type { QueuedCapture } from '../lib/offline/db';
import { registerOfflineSync } from '../lib/offline/sync';
import { useOnlineStatus } from './useOnlineStatus';

/** Reads the offline queue and keeps it in sync with reconnection.
 * Backs CA-06 (flagged/queue list) and any screen that needs to show
 * "N captures waiting to upload". */
export function useOfflineQueue() {
  const [queue, setQueue] = useState<QueuedCapture[]>([]);
  const [lastResult, setLastResult] = useState<ProcessQueueResult | null>(null);
  const online = useOnlineStatus();

  const refresh = useCallback(async () => {
    setQueue(await listQueue());
  }, []);

  useEffect(() => {
    void refresh();
    const unregister = registerOfflineSync((result) => {
      setLastResult(result);
      void refresh();
    });
    return unregister;
  }, [refresh]);

  const flushNow = useCallback(async () => {
    const result = await processQueue();
    setLastResult(result);
    await refresh();
    return result;
  }, [refresh]);

  return { queue, online, lastResult, refresh, flushNow };
}
